import { createSlice } from "@reduxjs/toolkit";

const initialEstimateStatusesState = {};

const estimateStatusesSlice = createSlice({
  name: "estimateStatuses",
  initialState: initialEstimateStatusesState,
  reducers: {
    setEstimatesStatusesData: (_state, action) =>
      action.payload.reduce((prev, curr) => ({ ...prev, [curr.id]: curr }), {}),
  },
});

export const { setEstimatesStatusesData } = estimateStatusesSlice.actions;

export const estimateStatuses = estimateStatusesSlice.reducer;

export default estimateStatusesSlice.reducer;
